import { ChangeDetectionStrategy, Component, Input, QueryList } from '@angular/core';
import { FormControl } from '@angular/forms';
import { TemplateDirective } from '@fleet-beat/core';
import { AnexConfig } from '../../models/anex-config.model';

@Component({
  selector: 'fb-anex',
  templateUrl: './anex.component.html',
  styleUrls: ['./anex.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AnexComponent {
  @Input() config: AnexConfig;
  @Input() templates: QueryList<TemplateDirective<object>>;
  @Input() control: FormControl;
  @Input() position: 'start' | 'end' = 'start';
}
